import React, { useState, useCallback } from 'react';
import './file-selection-button.scss';
import { TrashIcon, FileIcon } from 'assets/icons';
import cn from 'classnames';

interface IFileSelectionButton {
  onFileChange: (file?: File) => void;
  label?: string;
  keyFile?: boolean;
  icon?: React.ReactNode;
  hoverable?: boolean;
}

export default function FileSelectionButton({
  onFileChange,
  label,
  keyFile,
  icon,
  hoverable = false,
}: IFileSelectionButton) {
  const [file, setFile] = useState<File>();

  const onFileInputChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target.files) {
        const file = event.target.files[0];
        setFile(file);
        onFileChange(file);
      }
    },
    [onFileChange]
  );

  const onClearFile = useCallback((e) => {
    e.stopPropagation();
    setFile(undefined);
    onFileChange(undefined);
  }, []);

  return (
    <div
      className={cn('file-selection-button', {
        'file-selection-button_key-file': keyFile,
        'file-selection-button_hoverable': hoverable,
        'file-selection-button_selected': hoverable && file,
      })}
    >
      <input
        type="file"
        className="file-selection-button__file-input"
        onChange={onFileInputChange}
      />
      <div
        className="file-selection-button__file-input-container flex align-center cursor-pointer"
        role="button"
      >
        <div className="mr_16">{icon || <FileIcon />}</div>
        {file ? (
          <div>
            <span className="p p_font-size_12 p_color_light-grey no-select">
              {label || 'Выберите файл'}
            </span>
            <span className="p p_color_grey no-select">{file.name}</span>
          </div>
        ) : (
          <span className={`p p_color_grey no-select ${keyFile && 'p_bold'}`}>
            {label || 'Выберите файл'}
          </span>
        )}
      </div>
      {file && (
        <div className="file-selection-button__delete">
          <TrashIcon
            className="ml_16 cursor-pointer"
            role="button"
            onClick={onClearFile}
          />
        </div>
      )}
    </div>
  );
}
